<template>
  <div class="teach-source">
    <div class="center">
      <p class="description">下方是可以輔助您將 DFC 學習法融入課堂中的各式教學資源，可以搭配您的教學自由運用，若有任何使用上的回饋，歡迎跟我們及時反應喔！</p>
    </div>
    <div class="steps">
      <button v-for="item in steps" :class="{'active':step===item}" @click="getTag(item)">{{ item }}</button>
    </div>
    <el-table :data="dataList.list" fit stripe style="width: 100%;">
      <el-table-column prop="title" label="名稱" />
      <el-table-column prop="brief" label="簡介">
        <pre slot-scope="{row}">{{row.brief}}</pre>
      </el-table-column>
      <!-- <el-table-column prop="frequency" label="點擊次數" width="120"/> -->
      <!-- <el-table-column prop="goal" label="目標">
        <pre slot-scope="{row}">{{row.goal}}</pre>
      </el-table-column> -->
      <el-table-column label="" align="center" width="50">
        <template slot-scope="{row}">
          <a :href="API.track(row.link)" target="_blank">預覽</a>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="frequency" label="下載次數" /> -->
    </el-table>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import API from "@/api";

export default {
  props: {
		step: String,
	},
  model: {
    event: "stepChange",
  },
  data() {
    return {
      API,
      steps:['認識 DFC 學習法','感受','想像','實踐','分享','議題式教案'],
      activeTag: '認識 DFC 學習法'
    };
  },
  computed: {
    ...mapState('EduResource', ['dataList']),
  },
  methods: {
    getTag(value){
      this.activeTag = value;
      this.$emit("stepChange", value);
    },
    getView(id){
      console.log(id);
    }
  },
  created() { },
  mounted() {
    this.$emit("stepChange", '認識 DFC 學習法');
  },
  components: {}
};
</script>

<style lang="scss" scoped>
.teach-source {
  .description {
    max-width:435px;
    line-height: 1.5em;
    text-align: center;
  }
  .pagination {
    margin-top: 50px;

    .el-pagination {
      display: flex;
      justify-content: center;
    }
  }
  .steps{
    width: 100%;
    display: flex;
    border-bottom: 1px solid #D9D9D9;
    button{
      width: 100%;
      background-color: #fff;
      border: 0px;
      padding: 11px;
      font-weight: 500;
      font-size: 14px;
      position: relative;
      cursor: pointer;
    }
    button.active::after{
      content: '';
      width: 100%;
      height: 3px;
      background-color: #60ADF5;
      position: absolute;
      bottom: 0;
      transform: translateY(50%);
      left: 0;
    }
  }
}
</style>